/**
 * Sumy pieniężne rozbite po walucie.
 *
 * Kwoty w różnych walutach NIGDY nie wpadają do jednej liczby — do 2026-08-27
 * kafle statystyk sumowały `partner_commissions.amount` bez patrzenia na
 * `currency` i podpisywały wynik twardym „PLN", podczas gdy wiersze były w EUR.
 * Suma jest słownikiem waluta→kwota, a format pokazuje wszystkie waluty.
 */

export type KwotyWgWalut = Record<string, number>;

/** Dolicza kwotę do sumy właściwej waluty (kod normalizowany do wielkich liter). */
export function dodajKwote(
  sumy: KwotyWgWalut,
  waluta: string | null | undefined,
  kwota: number
): KwotyWgWalut {
  // Brak waluty w wierszu = default kolumny, a ten od migracji 653 to PLN.
  const kod = (waluta || 'PLN').toUpperCase();
  sumy[kod] = (sumy[kod] || 0) + kwota;
  return sumy;
}

export function formatujKwote(kwota: number): string {
  return kwota.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Surowa suma kwot ze wszystkich walut — WYŁĄCZNIE do progów typu „czy coś
 * w ogóle jest" (puste/niepuste, trend góra/dół), nigdy do pokazania kwoty.
 */
export function sumaKwot(sumy: KwotyWgWalut | null | undefined): number {
  if (!sumy) return 0;
  return Object.values(sumy).reduce((acc, kwota) => acc + kwota, 0);
}

/**
 * „19,50 EUR" albo „19,50 EUR + 1 200,00 PLN", gdy sumy obejmują kilka walut.
 * Pusta suma → „0,00 PLN" (zero w walucie kanonicznej).
 */
export function formatujKwotyWgWalut(sumy: KwotyWgWalut): string {
  const wpisy = Object.entries(sumy)
    .filter(([, kwota]) => kwota !== 0)
    .sort(([a], [b]) => a.localeCompare(b));
  if (wpisy.length === 0) return '0,00 PLN';
  return wpisy.map(([waluta, kwota]) => `${formatujKwote(kwota)} ${waluta}`).join(' + ');
}
